import {
  DismissIcon,
  JaneGoldIcon,
  TagFilledIcon,
  Typography,
} from '@iheartjane/reefer';

import styles from './qualifiedBundleBanner.module.css';

type QualifiedBundleBannerVariant = 'brand-special' | 'store-special';

export interface QualifiedBundleBannerProps {
  onDismiss: () => void;
  specialTitle: string;
  variant?: QualifiedBundleBannerVariant;
}

export const QualifiedBundleBanner = ({
  onDismiss,
  specialTitle,
  variant = 'brand-special',
}: QualifiedBundleBannerProps) => {
  const label =
    variant === 'brand-special'
      ? `The "${specialTitle}" Jane Gold reward has been applied to your bag.`
      : `The "${specialTitle}" special has been applied to your bag.`;
  const icon =
    variant === 'brand-special' ? (
      <JaneGoldIcon />
    ) : (
      <TagFilledIcon color="info" />
    );
  const backgroundColor =
    variant === 'brand-special'
      ? 'var(--colors-brand-gold-light)'
      : 'var(--colors-info-light)';

  return (
    <div className={styles['banner']} style={{ backgroundColor }}>
      <div className={styles['banner_content']}>
        {icon}
        <Typography as="p" color="grays-black" variant="body-semibold">
          {label}
        </Typography>
      </div>
      <div>
        <DismissIcon
          ml={16}
          onClick={onDismiss}
          color="grays-black"
          altText="dismiss banner"
        />
      </div>
    </div>
  );
};
